const base64ToBlob = (base64, mime = '', name = '') => {
  const sliceSize = 1024;
  const byteChars = window.atob(base64);
  const byteArrays = [];
  for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
    const slice = byteChars.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: mime, name });
};
export {
  base64ToBlob
};
